export interface Facet{
    key:string
    title: string
    type: FacetType
    options: FacetOption[]
}

export interface FacetOption{
    label: string
    value: any
    selected: boolean
    count: number
}

export enum FacetType 
{
    None = 0,
    JobType = 1,
    JobLocation = 2,
    JobCategory = 3,
    JobPosition = 5,
    JobSearchScope = 6,
    JobCandidateStatus = 7,
    JobCandidatePhase = 8
}
